<template>
  <div id="app">
    <header class="header">
    <div class="marquee-container">
      <div class="marquee-content">
        <span>Welcome to our online store! Great products at affordable prices, quality guaranteed!</span>
      </div>
    </div>
    <div class="header-main">
      <div class="top-banner">
        <div class="logo"><router-link to="/"><img src="@/assets/imgs/logo.png" alt=""></router-link></div>
        <h1>
          <router-link to="/">{{ t('app.title') }}</router-link>
        </h1>
        <div class="head-col">
          <div class="head-search"> 
            <!--<div class="head-search-cont" :class="{ 'show-search': isSearchVisible }">
              <div class="searchlogo"><img src="@/assets/imgs/logo.png" alt=""></div>
                <input 
                id="search-input" 
                type="text" 
                aria-label="Search"
                v-model="searchQuery"
                @keyup.enter="gotoSearch"
                >
                <div class="ico ico-search" @click="gotoSearch"></div>
                <div class="ico ico-close" @click="toggleSearch(false)"></div>
            </div>-->
            <div class="searchlogo" @click="goHome"><img src="@/assets/imgs/logo.png" alt=""></div>
            <input class="search-input"
                id="search-input" 
                type="text" 
                aria-label="Search"
                v-model="searchQuery"
                @keyup.enter="gotoSearch"
                >
                <div class="ico ico-search" @click="gotoSearch"></div>
            <!--<div class="ico ico-search" @click="toggleSearch(true)"></div>-->
          </div>
          <div class="ico ico-shoppingcart" @click="goIfLogin('/cate')"><span v-if="cartCount > 0" class="cart-count">{{ cartCount }}</span></div>
          <div class="ico ico-circular-user" @click="handleAccountClick"></div>
          <div class="language-selector">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
      <div class="head-cont">
        <div class="head-nav">
          <ProductDropdown></ProductDropdown>
        </div>
        <menu>
          <div class="menu-cont">
            <li><router-link to="/">{{ t('header.home') }}</router-link></li>
            <li><router-link to="/shop">{{ t('header.deals') }}</router-link></li>
            <li><a>{{ t('header.services') }}</a></li>
            <li><a>{{ t('header.diy') }}</a></li>
            <li><router-link to="/tender-list">{{ t('header.tender') }}</router-link></li>
          </div>
        </menu>
        <div class="head-other">
           <button class="btn btn-empty" @click="goReleaseIfLogin()">{{ t('Release.dr') }}</button>
           <!-- <button class="btn btn-empty">{{ t('header.storeFinder') }}</button> -->
           <button class="btn btn-empty" @click="router.push('/merchants-join')">{{ t('header.merchant') }}</button>
           <div style="display:inline-block;position:relative;">
            <!-- 监听事件：登录成功后刷新状态 -->
            <LoginPop
              :visible="showLogin"
              :target="accountBtn"
              @close="showLogin = false"
              @login-success="updateLoginStatus()"
            />
            <ReleaseTask
              :visible="showReleaseTask"
              @close="handleCloseReleaseTask"
            />
            <UserMenu
              v-if="showUserMenu && isLogin"
              @logout="handleLogout"
              @close="showUserMenu = false"
              style="position:absolute;right:0;top:40px;z-index:3000;"
            />
          </div>
          </div>
      </div>

    </div>
    </header>
    <main>
      <router-view />
    </main>
    <footer class="footer">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-section">
            <h4>{{ t('footer.customerService') }}</h4>
            <ul>
              <!-- <li><a href="#">{{ t('footer.help') }}</a></li> -->
              <!-- <li><a href="#">{{ t('footer.orderStatus') }}</a></li> -->
              <li><router-link to="/returnPolicy">{{ t('footer.returns') }}</router-link></li>
              <!-- <li><a href="#">{{ t('footer.contact') }}</a></li> -->
            </ul>
          </div>
          <div class="footer-section">
            <h4>{{ t('footer.about') }}</h4>
            <ul>
              <li><router-link to="/companyInfo">{{ t('footer.companyInfo') || 'Company Info' }}</router-link></li>
              <li><router-link to="/careers">{{ t('footer.careers') }}</router-link></li>
              <li><router-link to="/responsibility">{{ t('footer.responsibility') || 'Corporate Responsibility' }}</router-link></li>
              <!-- <li><a href="#">{{ t('footer.investors') }}</a></li> -->
            </ul>
          </div>
          <div class="footer-section">
            <h4>{{ t('footer.services') }}</h4>
            <ul>
              <!-- <li><router-link to="/">{{ t('footer.professionalServices') }}</router-link></li> -->
              <li><router-link to="/installService">{{ t('footer.installationServices') }}</router-link></li>
              <li><router-link to="/deliveryService">{{ t('footer.deliveryOptions') }}</router-link></li>
              <li><router-link to="/financingService">{{ t('footer.financingOptions') }}</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>{{ t('footer.connectWithUs') }}</h4>
            <div class="social-icons">
              <p>{{ t('footer.phone') }}</p>
              <h3>(437) 771-6666</h3>
            </div>
            <!-- <p>{{ t('footer.socialMedia') }}</p> -->
            <!-- <div class="foot-sns">
              <a href="#" class="ico ico-wechat"></a>
              <a href="#" class="ico ico-douyin"></a>
              <a href="#" class="ico ico-telegram"></a>
              <a href="#" class="ico ico-applets"></a>
              <a href="#" class="ico ico-weibo"></a>
            </div> -->
          </div>
        </div>
        <div class="footer-bottom">
          <p style="color:#ffffff">{{ t('footer.copyright', { year: currentYear }) }}</p>
          <div class="footer-links">
            <router-link to="/policy">{{ t('footer.privacy') || 'Privacy Policy' }}</router-link>
            <router-link to="/termsUse">{{ t('footer.terms') || 'Terms of Use' }}</router-link>
          </div>
        </div>
      </div>
    </footer>

    <!-- 手机端底部导航栏 -->
    <nav class="mobile-bottom-nav">
      <button class="nav-item" @click="goHome()">
        <span class="icon">🏠</span>
        <span class="label">{{ t('header.home') }}</span>
      </button>
      <button class="nav-item" @click="goToMerchantJoin_m()">
        <!-- <span class="icon">🛍️</span>
        <span class="label">{{ t('header.shop') }}</span> -->
        <span class="icon">🏬</span>
        <span class="label">{{ t('header.merchant')}}</span>
      </button>
      <button class="nav-item" @click="goIfLogin('/profile-information')">
        <span class="icon">👤</span>
        <span class="label">{{ t('header.account') }}</span>
      </button>
      <button class="nav-item" @click="goIfLogin('/cate')">
        <span class="icon">🛒</span>
        <span class="label">{{ t('header.cart') }}</span>
        <span v-if="cartCount > 0" class="cart-count">{{ cartCount }}</span>
      </button>
      <!-- 新增菜单按钮 -->
      <button class="nav-item menu-btn" @click="openMobileMenu">
        <span class="icon">☰</span>
        <span class="label">{{ t('header.menu')}}</span>
      </button>
    </nav>
    <!-- Mobile Menu -->
    <MobileMenu :is-active="mobileMenuActive" @close="closeMobileMenu" @open-login-pop="showLogin = true"
      @open-release-pop="showReleaseTask = true" @logout="handleLogout" :is-login="isLoggedIn" />
    <!-- PWA Install Prompt -->
    <InstallPrompt />

    <!-- 新增装修发布弹窗组件 -->
    <ReleaseTask :visible="showReleaseTask" @close="showReleaseTask = false" />

    
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, nextTick, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';

// 立即执行的日志，确认组件被加载
console.log('🚀 MainLayout component is being loaded!');

// 搜索框显示状态
const isSearchVisible = ref(false);
const cartCount = ref(0);
// 切换搜索框显示状态
const toggleSearch = async (show: boolean) => {
  isSearchVisible.value = show;
  if (show) {
    // 等待DOM更新完成
    await nextTick();
    const input = document.querySelector('#search-input') as HTMLInputElement;
    input.focus();
  }
};
import MobileMenu from '@/components/layout/MobileMenu.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import InstallPrompt from '@/components/pwa/InstallPrompt.vue';
import LoginPop from '@/views/LoginRegister/LoginPop.vue';
import ReleaseTask from '@/views/ReleaseTasks/ReleaseTask.vue'; // 1. 引入
import ProductDropdown from '@/components/ProductDropdown.vue'; // 2. 引入 ProductDropdown 组件
import UserMenu from "@/views/LoginRegister/UserMenu.vue";
import { useRouter } from 'vue-router';
import eventBus from '@/utils/eventBus.js';
import { getToken } from '@/services/auth';
// import { get } from 'http';

const { t } = useI18n();
const currentYear = computed(() => new Date().getFullYear());
const mobileMenuActive = ref(false);

// 登录弹窗相关
const showLogin = ref(false)
const accountBtn = ref<HTMLElement | null>(null)

const isLogin = ref(!!localStorage.getItem('token'))
const username = ref('')

// 1. 监听 localStorage 变化（兼容同域多窗口/iframe 以及 WKWebView 注入）
window.addEventListener('storage', (event) => {
  console.log('🔍 Storage event detected:', event.key, event.newValue)
  if (event.key === 'token') {
    console.log('📱 Token changed via storage event, updating login status')
    updateLoginStatus()
  }
})

// 注意：setTokenFromNative 函数已在 index.html 中预先定义
// 这样确保 WKWebView 可以在页面加载的任何阶段调用该函数

// 处理显示登录弹窗的函数
const handleShowLogin = () => {
  console.log('Received show-login event!')
  console.log('Current showLogin value:', showLogin.value)
  showLogin.value = true
  console.log('Updated showLogin value:', showLogin.value)
  console.log('Login modal should now be visible')
}
// 获取购物车数量
import { getShoppingCartList } from '@/api/order'
const getCartCount = () => {
  getShoppingCartList({}).then((res: any) => {
    // 遍历res.data，累加每个cartList的长度
    if (res.data.code == 401) {
      cartCount.value = 0;
      return;
    }
    cartCount.value = res.data.reduce((total: number, cart: any) => {
      return total + (cart.cartList?.length || 0);
    }, 0);
  }).catch(error => {
    console.error('Failed to fetch cart count:', error);
    cartCount.value = 0;
  });
}

// 初始化时读取
onMounted(() => {

  updateLoginStatus()
  
  // 监听显示登录弹窗事件
  eventBus.on('show-login', handleShowLogin);
  
  // 监听购物车更新事件
  eventBus.on('update-cart-count', getCartCount);

  // 注册 Service Worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('./sw.js')
      .then(registration => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(error => {
        console.error('ServiceWorker registration failed: ', error);
      });
  }
  getCartCount()
});

// 组件销毁时清理事件监听
onBeforeUnmount(() => {
  console.log('Cleaning up event listeners...')
  eventBus.off('show-login', handleShowLogin);
  eventBus.off('update-cart-count', getCartCount);
});

// 登录/退出登录后调用此方法
function updateLoginStatus() {
  getCartCount()
  console.log('updateLoginStatus called')
  isLogin.value = !!getToken()
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    console.log('userInfo:', userInfo)
    username.value = userInfo.nickname || ''
  } catch {
    username.value = ''
  }
}

const showUserMenu = ref(false)

function handleAccountClick() {
  const token = getToken()
  if (token) {
    // 如果已登录，切换 user-menu 显示
    showUserMenu.value = !showUserMenu.value
  } else {
    // 如果未登录，显示登录弹窗
    showLogin.value = true
  }
}

// 装修发布弹窗相关
const showReleaseTask = ref(false);

// 发布任务弹窗
const handleCloseReleaseTask = () => {
  console.log('Closing release task modal');
  showReleaseTask.value = false;
};

function openMobileMenu() {
  if (mobileMenuActive.value) {
    closeMobileMenu();
    document.body.classList.remove('no-scroll');
    return;
  }
  mobileMenuActive.value = true;
  document.body.classList.add('no-scroll');
}

function closeMobileMenu() {
  if (!mobileMenuActive.value) {
    openMobileMenu() ;
    return;
  };
  mobileMenuActive.value = false;
  document.body.classList.remove('no-scroll');
}

function goToMerchantJoin() {
  const base = window.location.origin + (import.meta.env.BASE_URL || '/');
  window.open(base + '#/merchants-join', '_blank');
}

function goToMerchantJoin_m() {
  router.push('/merchants-join')
}

const router = useRouter()
const emits = defineEmits(['close', 'open-login-pop']);
function goIfLogin(route?: string){
  const token = getToken()
  if (token) {
    showReleaseTask.value = false;
    if (route) {
      router.push(route)
    }
  } else {
    
    showLogin.value = true
  }
}

function goReleaseIfLogin(){
  const token = getToken()
  if (token) {
    showReleaseTask.value = true;
  } else {
     showReleaseTask.value = false;
    showLogin.value = true
  }
}


function goHome() {
  router.push('/#')
}

function goToMessages() {
  router.push('/messages');
}


// 新增 LoginPop 和 UserMenu 的逻辑
const showLoginPop = ref(false)
const isLoggedIn = ref(!!localStorage.getItem('token'))

function onLoginSuccess() {
  showLoginPop.value = false
  isLoggedIn.value = true
}

function handleLogout() {
  localStorage.removeItem('token')
  isLoggedIn.value = false
  updateLoginStatus()
}

// 进入搜索页面
const searchQuery = ref('')
const gotoSearch = () => {
  if (searchQuery.value.trim()) {
    router.push({
      name: 'shopSearch',
      query: { q: searchQuery.value.trim() }
    })
  }
}
</script>

<style lang="scss">
// Use modern Sass directive with explicit namespace
@use '@/assets/styles/main.scss';

.marquee-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  background-color: #fb6e01;
  color: white;
  padding: 5px 0;
  
  .marquee-content {
    display: inline-block;
    padding-left: 100%;
    animation: marquee 20s linear infinite;
    
    span {
      display: inline-block;
      padding-right: 50px;
    }
  }
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

// Variables
$primary-color: #ffffff; // Home Depot orange
$secondary-color: #ffffff; // Home Depot blue
$light-gray: #f8f9fa;
$dark-gray: #333;
$white: #fb6e01;
$breakpoint-md: 768px;
$breakpoint-sm: 576px;

// Reset
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.show-search{
  display: flex!important;
}
body {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $dark-gray;
  line-height: 1.6;
  font-size: 16px;

  &.no-scroll {
    overflow: hidden;
  }
}
.searchlogo{
  display: none!important;
}
.logo {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: auto;
  left: 0;
  top: 0;
  overflow: hidden;

  a{
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    img{
      height: 163%;
    }
  }
}
// Container
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}
.head-col {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  padding: 20px 0;
  z-index: 1;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1;
  padding: 0;
}

// Header
.header {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.top-banner {
  background-color: $primary-color;
  padding: 0;
  text-align: center;
  font-weight: bold;
  height: 90px;
  position: relative;
}

.top-banner h1 {
  font-size: 30px;
  line-height: 90px;
  text-align: center;
}
.top-banner h1 a{
  color: $white;
  text-decoration: none;
}
.cart-count{
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-color: #fb6e01;
    color: white;
    border-radius: 100%;
    text-align: center;
    line-height: 20px;
    font-size: 14px;
}
.head-cont {
    position: relative;
    border-top: 1px #eee solid;
    height: 60px;
}
menu {
    text-transform: capitalize;
    display: block;
    width: 90%;
}
.menu-cont {
    text-align: center;
    display: block;
}
.menu-cont li {
    cursor: pointer;
    position: relative;
    display: inline-block;
}
.menu-cont li a {
    line-height: 60px;
    height: 60px;
    font-size: 1.2rem;
    padding: 0 17px;
    border-bottom: 2px transparent solid;
    display: block;
    user-select: none;
    color: #000000;
    font-weight: 500;
}
.menu-cont li a:hover {
    border-bottom: 2px #fb6e01 solid;
    text-decoration: none;
    color: #fb6e01;
}
.head-nav {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.head-other {
    position: absolute;
    top: 0;
    right: 0;
    padding: 12px 0;
}
.head-other button {
    height: 36px;
    color: #000000;
    border: 1px #ddd solid;
    background-color: transparent;
    font-size: 1rem;
    border-radius: 100px;
    text-transform: capitalize;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 7px;
    user-select: none;
    position: relative;
    margin: 0 3px;
    cursor: pointer;
    &:hover {
        color: #fb6e01;
        border-color: #fb6e01;
        text-decoration: none;
    }
}

.header-main {
  width: 90%;
  max-width: 1539px;
  padding: 0;
  position: relative;
  margin: auto;

  .header-actions {
    display: flex;
    align-items: center;

    button,
    a {
      background: none;
      border: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 15px;
      cursor: pointer;
      font-size: 14px;
      color: #000000;

      .icon {
        font-size: 20px;
        margin-bottom: 5px;
      }
    }
  }

  .mobile-menu-btn {
    display: none;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }
}
.search-input{
  border: 1px #000000 solid;
  padding-left: 18px;
  height: 38px;
  border-radius: 8px;
}

// Footer
.footer {
  background-color: #222222;
  color: $white;
  padding: 40px 0 66px;
  margin-top: auto;

  a {
    color: #666666;
    text-decoration: none;

    &:hover {
      color: #ffffff;
    }
  }
  p,span{
    color: #666666;
  }

  .footer-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    margin-bottom: 30px;
  }

  .footer-section {
    h4 {
      color: #ffffff;
      margin-bottom: 15px;
      font-size: 18px;
    }

    ul {
      list-style: none;

      li {
        margin-bottom: 10px;
      }
    }
  }

  .social-icons {
    gap: 10px;
    margin-bottom: 20px;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 50%;

      &:hover {
        background-color: $primary-color;
      }
    }
  }

  .foot-sns {
    padding: 10px 0;
  }
  .foot-sns a {
    color: white;
    font-size: 36px;
    padding: 8px;
    border-radius: 10px;
  }
  .ico-wechat:before {
    content: "\eb6f";
  }
  .ico-douyin:before {
    content: "\e87e";
  }
  .ico-telegram:before {
    content: "\e64d";
  }
  .ico-applets:before {
    content: "\ecbd";
  }
  .ico-weibo:before {
    content: "\eb75";
  }

  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    p {
      margin: 0;
    }

    .footer-links {
      display: flex;
      gap: 20px;
    }
  }
}


.mobile-bottom-nav{
  display: none;
}
// Responsive styles
@media (max-width: $breakpoint-md) {
  .header-main {
    width: 100%;
    .search-bar {
      order: 3;
      margin: 15px 0 0;
      max-width: 100%;
      width: 100%;
    }

    .header-actions {
      margin-left: auto;

      button .text {
        display: none;
      }
    }
  }


  .footer-grid {
    grid-template-columns: repeat(2, 1fr)!important;
  }

  .footer-bottom {
    flex-direction: column;
    text-align: center;

    p {
      margin-bottom: 15px;
    }
  }
}

@media (max-width: $breakpoint-sm) {
  .header-main {
    justify-content: space-between;
    width: 100%;

    .logo {
      display: none;
    }
    .searchlogo{
      display: flex!important;
      height: 50px;
      width: 54px;
      overflow: hidden;
    }
    .searchlogo img{
        max-width: 69px;
        width: 69px;
        height: 69px;
        margin-left: -10px;
        margin-top: -8px;
    }

    .mobile-menu-btn {
      display: block;
    }

    .header-actions {
      display: none;
    }
  }
  .top-banner h1 {
    font-size: 20px;
    line-height: 60px;
    text-align: left;
    display: none;
  }
  .head-col{
    padding: 6px 0!important;
    width: 100%;
  }
  .search-input{
    height: 34px;
    flex: 1;
  }
  .head-col .ico {
    font-size: 26px!important;
    width: 33px!important;
}
  .head-cont,.ico-circular-user,.ico-shoppingcart {
    display: none!important;
  }
  .head-search-cont{
    position: fixed!important;
    top: 60px!important;
    width: 100%!important;
}
.top-banner{
  height: 60px!important;
}


  .mobile-bottom-nav {
    .nav-item {
     

      .icon {
        font-size: 22px;
        margin-bottom: 2px;
      }

      .label {
        font-size: 11px;
      }

      &.active {
        color: $primary-color;
        font-weight: 600;
      }
    }
  }

  .mobile-bottom-nav .menu-btn {
    background: none !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 0;
    margin: 0;
    height: 100%;
    width: 100%;
    appearance: none;
  }

  .mobile-bottom-nav .menu-btn:active,
  .mobile-bottom-nav .menu-btn:focus {
    background: none !important;
    outline: none !important;
    box-shadow: none !important;
  }
}

// 让页面底部不被导航遮挡
@media (max-width: $breakpoint-sm) {
  main {
    padding-bottom: max(62px, calc(56px + env(safe-area-inset-bottom)));
  }

  .mobile-bottom-nav {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3000;
    background: #fff;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.04);

    // Use CSS variables for better browser support
    padding-bottom: max(0px, env(safe-area-inset-bottom));
    padding-left: max(0px, env(safe-area-inset-left));
    padding-right: max(0px, env(safe-area-inset-right));

    // Base height plus safe area
    height: calc(56px + max(0px, env(safe-area-inset-bottom)));
    min-height: 56px;

    .nav-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #888;
      font-size: 12px;
      text-decoration: none;
      padding: 8px 2px;
      height: 56px; // Fixed content height
      position: relative;

      .icon {
        font-size: 22px;
        margin-bottom: 2px;
      }

      .label {
        font-size: 11px;
      }

      &.active {
        color: $primary-color;
        font-weight: 600;
      }
    }
  }

  .mobile-bottom-nav .menu-btn {
    background: none !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 0;
    margin: 0;
    height: 100%;
    width: 100%;
    appearance: none;
  }
}
</style>
